<script type="text/babel">
import ManagesModalState from "dashboard-js/mixins/ManagesModalState";
import RestoreScrollOnPageBack from "dashboard-js/mixins/RestoreScrollOnPageBack";

export default {
  mixins: [ManagesModalState, RestoreScrollOnPageBack],

  props: ["course", "slide", "user"],

  data() {
    return {};
  },

  computed: {},

  created() {},

  methods: {
    onSlideBack() {
      const currentSortOrder = this.slide.sort_order;
      if (currentSortOrder > 1) {
        const prevSlide = this.course.course_slide.find((slide) => slide.sort_order === currentSortOrder - 1);
        if (prevSlide) {
          window.location.pathname = `/school/course/${this.course.id}/slide/${prevSlide.id}`;
        }
      }
    },
    onSlideNext() {
      const currentSortOrder = this.slide.sort_order;
      const nextSlide = this.course.course_slide.find((slide) => slide.sort_order === currentSortOrder + 1);
      if (nextSlide) {
        window.location.pathname = `/school/course/${this.course.id}/slide/${nextSlide.id}`;
      }
    },
    getDate(timestamp) {
      return moment(timestamp).format("MMMM d, yyyy");
    },
    navigateToQuestions() {
      if (!this.course.course_question.length) {
        return;
      }

      window.location.pathname = `/school/course/${this.course.id}/question/${this.course.course_question[0].id}`;
    },
  },
  computed: {
    currentStep() {
      return this.slide.sort_order;
    },
    isFirstStep() {
      return this.currentStep === 1;
    },
    isLastStep() {
      return this.currentStep === this.course.course_slide.length;
    },
  },
};
</script>
